import styled from 'styled-components';
import { layout } from 'src/components/base';
import { ToggleButton } from '@prisjakt/ui/button/variants';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px;
`;

export const SelectableButton = styled(ToggleButton)`
  display: flex;
  min-height: 40px;
  min-width: 80px;
  margin-right: ${layout.measurements.spacing050};
`;

export const ConditionHeader = styled.div`
  margin: 0 0 ${layout.measurements.spacing075};
`;
